import(/* webpackMode: "eager" */ "/app/src/css/globals.css");
;
import(/* webpackMode: "eager" */ "/app/src/css/fonts.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/providers/ProgressProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/registry/styled-jsx.tsx");
